module.exports = __webpack_public_path__ + "static/img/wx-img.3573c226.jpg";